import React from 'react'
import { Row, Col } from 'react-bootstrap'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ISpecialOffers } from '../../types/api/homeApi';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { NoData } from '../common/NoData';
import { useTranslation } from 'react-i18next';
import { ISubSpecialOffer } from '../../types/features/multiLanguageSlice';

const Offer: React.FC<{ special_offers: Array<ISpecialOffers> }> = ({ special_offers }) => {
const {t} = useTranslation();
const special_offer_json = t('home.special_offer.special_offers', { returnObjects: true })  as ISubSpecialOffer[];

    return (
        <section className='offer inner-padding'>
            <div className='container'>
                <div className='title-heading'>
                    <h5>{t('home.special_offer.best_price')}</h5>
                    <h3>{t('home.special_offer.title')}</h3>
                </div>
                <div className='offer-info'>
                    <Row>
                        {
                            special_offers && special_offers.length > 0 ?
                                special_offers.map((special_offer: ISpecialOffers, index: number) => (
                                    <Col md={6} sm={6} lg={4} key={"Offer_" + index}>
                                        <div className='offer-box'>
                                            <div className='offer-image'>
                                                <img src={special_offer.photo} alt='demo' />
                                            </div>
                                            <div className='offer-box-details'>
                                                <h4>{special_offer_json[index].title}</h4>
                                                <div className='price'>
                                                    <h6>${special_offer_json[index].price}  <span>/ {t('home.special_offer.daily')}</span></h6>
                                                </div>
                                                <ul>
                                                    {
                                                        special_offer_json[index]?.descriptions && special_offer_json[index]?.descriptions?.length ?
                                                        special_offer_json[index]?.descriptions.map((des: string, index: number) => (
                                                                <li key={"offer_descrption_" + index}>
                                                                    <i className="bi bi-check-circle-fill"></i>
                                                                    {des}
                                                                </li>
                                                            ))
                                                            : <NoData message='No Offer description found.' />
                                                    }

                                                </ul>
                                            </div>
                                        </div>
                                    </Col>
                                ))

                                : <NoData message='Oops!! No Offer Data Found.' />
                        }
                    </Row>
                </div>
            </div>
        </section>
    )
}

export default Offer